import $ from 'jquery';

$(function() {
    
    $('mobile-menu-block:not(.editor)').find('menu-icon').on('click', function() {
        
        var $wrapper = $(this).closest('mobile-menu-block');
        $wrapper.addClass('open');
        
        $wrapper.find('menu-icon').fadeOut(100, function() {
            $wrapper.find('menu-close-icon').fadeIn(100);
        });
        
        $wrapper.find('menu-modal').fadeIn(100);
        $('html').addClass('mobile-menu-open');
        
        $wrapper.find('menu-item').removeClass('open');
        
    });
    
    $('mobile-menu-block:not(.editor)').find('menu-close-icon').on('click', function() {
        
        var $wrapper = $(this).closest('mobile-menu-block');
        $wrapper.removeClass('open');
        
        $wrapper.find('menu-close-icon').fadeOut(100, function() {
            $wrapper.find('menu-icon').fadeIn(100);
        });
        
        $wrapper.find('menu-modal').fadeOut(100);
        $('html').removeClass('mobile-menu-open');
        
        $wrapper.find('menu-item').removeClass('open');
        
    });
    
    $('mobile-menu-block:not(.editor) menu-items > menu-item > a').on('click', function(e) {
        
        e.preventDefault();
        var $link = $(this);
        var $menu_item = $link.closest('menu-item');
        
        if( $menu_item.hasClass('has-children') ) {
            $menu_item.addClass('open');
        }
        else {
            location.href = $link.attr('href');
        }
        
    });
    
    $('mobile-menu-block:not(.editor) sub-menu all-link icon').on('click', function() {
        var $menu_item = $(this).closest('menu-item');
        $menu_item.removeClass('open');
    });
    
});